<!--<div class="navigation" fxLayout="row" fxLayoutAlign="start center" vexContainer>
  <ng-container *ngFor="let item of items">
    <vex-navigation-item *ngIf="item" [item]="item"></vex-navigation-item>
  </ng-container>
</div> -->


<div class="navigation flex items-center container">
  <vex-navigation-item *ngFor="let item of items" [item]="item"></vex-navigation-item>
</div>